<template>
    <v-layout row class="sort-selector">
        <v-flex class="flex-grow-overwrite">{{contentDirectoryPageConstant.label.SORT_BY}}</v-flex>
        <v-flex>
            <v-menu offset-y
                    class="ypo_cta_blue_color"
                    nudge-left="55"
                    nudge-bottom="10">
                <v-flex slot="activator"
                        class="sort-selection"
                        data-qe-id="content-directory_sort-label`">
                    {{currentSort.label}}
                    <v-icon size="19">arrow_drop_down</v-icon>
                </v-flex>
                <v-list class="sort-selector__options">
                    <v-list-tile
                            v-for="(sort, index) in contentSortOptions"
                            :key="sort.key"
                            :data-qe-id="`content-directory_sort-option-${index}`"
                            @click="currentSort = sort">
                        {{sort.label}}
                    </v-list-tile>
                </v-list>
            </v-menu>
        </v-flex>
    </v-layout>
</template>
<script>
    import { mapActions, mapGetters, mapMutations } from 'vuex';
    import { storeGetters } from "../../../store/storeGetters.constant";
    import { storeAction } from "../../../store/storeActions.constant";
    import { contentSortOptions, contentDirectoryPageConstant } from '../contentDirectoryPage.constant';
    import { storeMutation } from "../../../store/storeMutations.constant";
    import { removeLetterFilterForRolodex } from "../../EventDirectoryPage/eventDirectoryPage.constants";
    import { appConstant } from "../../../app.constant";

    export default {
        name: 'SortByContentOptions',
        data() {
            return {
                contentDirectoryPageConstant,
                contentSortOptions,
            };
        },
        watch: {
            currentSort() {
                if (this.contentDirectorySelectedLetterFilter) {
                    this.removeContentPillFromState(this.contentDirectorySelectedLetterFilter);
                    this.setContentSelectedLetterFilter();
                }

                removeLetterFilterForRolodex(
                    this.$route.query,
                    this.$router,
                    appConstant.storageKeys.contentDirectoryStoredFilters,
                );

                this.getContentDirectorySearchResults();
            },
        },
        methods: {
            ...mapActions({
                getContentDirectorySearchResults: `contentDirectory/${storeAction.getInitialContentDirectorySearchResults}`,
            }),
            ...mapMutations({
                setContentDirectorySort: `contentDirectory/${storeMutation.setContentDirectorySort}`,
                setContentSelectedLetterFilter: `contentDirectory/${storeMutation.setContentSelectedLetterFilter}`,
                removeContentPillFromState: `contentDirectory/${storeMutation.removeContentPillFromState}`,
            }),
        },
        computed: {
            ...mapGetters({
                contentDirectorySort: `contentDirectory/${storeGetters.contentDirectorySort}`,
                contentDirectorySelectedLetterFilter: `contentDirectory/${storeGetters.contentDirectorySelectedLetterFilter}`,
            }),
            currentSort: {
                get() {
                    return this.contentDirectorySort;
                },
                set(value) {
                    this.setContentDirectorySort(value);
                },
            },
            
        },
    };
</script>

<style lang="scss" scoped>
    @import '../../../common/styles/_colors.scss';
    @import '../../../common/styles/_responsive.scss';

    .sort-selector {
        background-color: $ypo-tile-bgcolor;
        line-height: 24px;
        width: 220px;
        padding: 10px;

        @include breakpoint(xs) {
            padding: 10px 5px;
            width: 215px;
        }

        & > * {
            vertical-align: middle;
        }

        &__options {
            width: 217px;

            @include breakpoint(xs) {
                width: 212px;
            }
        }

        .v-menu {
            width: 100%;

        }

    }

    .sort-selection {
        padding-left: 5px;
        margin-top: -3px;
        position: relative;

        .v-icon {
            color: $ypo-cta;
            position: absolute;
            right: 0;
            bottom: 2px;
        }
    }
</style>
